import {useMutation} from "@tanstack/react-query";

import {addServiceNoteMutationOptions} from "./add-service-note.mutation-options";

export function useAddServiceNote(id: string) {
  return useMutation(addServiceNoteMutationOptions(id));
}
